import { helper } from "@ember/component/helper"
import { startsWith } from "lodash-es"
import { getPatternUrl } from "./get-cover-pattern-style"

export function getCoverStyles(
  background: string,
  pattern: string | null | undefined,
  /** The image width to load. Only used for Imgix-sourced images. */
  loadWidth?: number | undefined
) {
  loadWidth = loadWidth || 2048
  let backgroundUrl = startsWith(background, "http")
    ? background
    : `https://imgix.commoncurriculum.com/covers/backgrounds/${background}?q=80&w=${loadWidth}`

  let patternUrl = getPatternUrl(pattern || "")

  return `--pattern-url: ${patternUrl}; --background-url: url('${backgroundUrl}');`
}

export default helper(
  ([background, pattern, loadWidth]: [string, string | null | undefined, number | undefined]) =>
    getCoverStyles(background, pattern, loadWidth)
)
